import { ISbStoryData, SbBlokData } from "@storyblok/react";
import { NewsStory } from "../types/NewsTypes";

/**
 * Transform Storyblok stories data into the NewsStory format.
 * Resolves relations and maps the data to NewsStory type.
 */
export const transformStoryblokToNews = (
  stories: ISbStoryData[] = [],
  rels: ISbStoryData[] = []
): NewsStory[] => {
  // Create a map where each relation is stored with its UUID as the key
  const relsMap = new Map<string, ISbStoryData>(
    rels.map((rel) => [rel.uuid, rel])
  );

  // Resolve an array of relation IDs into their corresponding Storyblok data objects
  const resolveRelations = (ids: unknown) => {
    return Array.isArray(ids)
      ? ids
          .filter((id): id is string => typeof id === "string")
          .map((id) => relsMap.get(id) || null)
          .filter((item): item is ISbStoryData => item !== null)
      : [];
  };

  return stories.map((story) => {
    const content = story.content ?? {};

    return {
      ...story,
      content: {
        ...content,
        cluster: resolveRelations(content.cluster),
        brand: resolveRelations(content.brand),
        categories: resolveRelations(content.categories),
        date: (content.date as string) ?? "",
        featuredImage:
          content.featuredImage &&
          typeof content.featuredImage === "object" &&
          "filename" in content.featuredImage
            ? ((file) => ({
                filename:
                  typeof file.filename === "string" ? file.filename : "",
                alt: typeof file.alt === "string" ? file.alt : "",
              }))(content.featuredImage as Record<string, unknown>)
            : { filename: "", alt: "" },
        body: (content.body as SbBlokData[]) ?? [],
      },
      translated_slugs: story?.translated_slugs ? [
        ...(story.translated_slugs as {
          lang: string;
          name: string;
          path: string;
        }[]),
      ] : [],
    } as NewsStory;
  });
};
